import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'onlyActive',
    pure: false,
    standalone: false
})
export class OnlyActivePipe implements PipeTransform {

  transform(array: Array<any>): Array<any> {
    if(array){
      return array.filter((a) => {
        return a.isChecked;
      });
    }

  }

}
